import React, { useState, useContext } from 'react';
import { Helmet } from 'react-helmet';
import GlobalStyle from '../styles/GlobalStyle';
import { Wrapper } from './ui';
import SitewideNotice from './SitewideNotice';
import Header from './Header';
import Footer from './Footer';
import Loader from './Loader';
import CheckoutHeader from './checkout/Header';
import CookieNotice from './CookieNotice';
import { StoreContext } from '../context/StoreContext';
import { useDataLayer } from '../utils';
import gustolleWoff2 from '../fonts/gustolle.woff2';

const Layout = ({
  dataLayer,
  headerBackgroundColour,
  altHeader,
  removeFooterNewsletter,
  altTheme,
  isCheckout,
  checkoutStep,
  isError,
  testVariation,
  children,
  isHomepage,
}) => {
  const [isNavActive, setNavActive] = useState(false);

  const { loaderActive, isOverlayActive, setOverlayActive } =
    useContext(StoreContext);

  useDataLayer(dataLayer);

  return (
    <>
      <Helmet>
        <html lang="en-GB" />
        <link
          rel="preload"
          href={gustolleWoff2}
          as="font"
          type="font/woff2"
          crossorigin
        />
        <link rel="preconnect" href="https://spaseekers.imgix.net" />
        {isCheckout && <meta name="robots" content="noindex, nofollow" />}
        {isHomepage && (
          <script type="text/javascript">
            {`
              if(!window.opt_data) window.opt_data = [];
              window.opt_data.push({
                data: {
                  "1457_homepage": "${testVariation}",
                }
              });
            `}
          </script>
        )}
        <script type="text/javascript">
          {`
            !function(){
              var src = "//c.webtrends-optimize.com/acs/accounts/${process.env.GATSBY_SPASEEKERS_WEBTRENDS_OPTIMIZE_ACCOUNT}/js/wt.js";
              var timeout = 2000; // 2 seconds 
              var css={add:function(c, id){if(c instanceof Array){c=c.join(' ')}var a=document.getElementsByTagName('head')[0],b=document.createElement('style');b.type='text/css';if(id){b.id=id;}if(b.styleSheet){b.styleSheet.cssText=c}else{b.appendChild(document.createTextNode(c))}a.appendChild(b)}, del:function(id){var el=document.getElementById(id); if(el){el.parentNode.removeChild(el)}}}; 
              var cssid = 'wt_tagHide'; 
              css.add('body { opacity: 0.000001 !important; }', cssid); 
           
              var sc = document.createElement('script');
              window.WT_ABORT = 0;
              sc.src = src;
              sc.onload = function(){ 
                 window.WT_ABORT = -1; 
                 css.del(cssid); 
              };
              sc.onerror = function(){
                 window.WT_ABORT = 1;
                 css.del(cssid); 
              };
           
              document.getElementsByTagName('head')[0].appendChild(sc);
              setTimeout(function(){
                 if(window.WT_ABORT !== -1) window.WT_ABORT = 1; 
                 css.del(cssid);
              }, timeout);
           }();
          `}
        </script>
      </Helmet>
      <GlobalStyle
        altTheme={altTheme}
        isOverlayActive={isOverlayActive}
        isCheckout={isCheckout}
      />
      {!isCheckout ? (
        <>
          {loaderActive && <Loader />}
          <SitewideNotice />
          <Wrapper>
            <Header
              backgroundColour={headerBackgroundColour}
              alt={altHeader}
              altTheme={altTheme}
              isNavActive={isNavActive}
              setNavActive={setNavActive}
            />
            {children}
            <Footer
              removeNewsletter={removeFooterNewsletter}
              altTheme={altTheme}
              isError={isError}
            />
          </Wrapper>
        </>
      ) : (
        <>
          {loaderActive && <Loader />}
          <CheckoutHeader step={checkoutStep} />
          {children}
        </>
      )}
      <CookieNotice setOverlayActive={setOverlayActive} />
    </>
  );
};

export default Layout;
